import { useEffect, useRef } from 'react';
import { BITRIX, PATHS } from 'common/constants';
import heroPhoto from 'assets/image/hmHeroPhoto.webp';
import heroShape from 'assets/icons/hmHeroShape.svg';
import heroArrow from 'assets/icons/hmHeroArrow.svg';
import HomeButton from './HomeButton';
import classes from './HomeHero.module.scss';


// Тексты приходят с бэкенда, значения из макета — запасные.
// Фото берём только из макета: в картинке из админки жёлтая фигура уже вшита,
// и поверх неё фигура блока давала второй логотип.
const FALLBACK = {
  title: 'Знания с гарантией',
  thesis: 'Изучайте IT и станьте экспертом в своей области',
};

// Сетка точек за первым экраном: вокруг курсора точки подсвечиваются жёлтым.
// Двигается только CSS-маска (переменные --mx/--my), без canvas и перерисовок React.
const useDotGrid = () => {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return undefined;

    let frame = 0;
    let x = 0;
    let y = 0;
    const apply = () => {
      frame = 0;
      node.style.setProperty('--mx', `${x}px`);
      node.style.setProperty('--my', `${y}px`);
    };
    const onMove = (event) => {
      const box = node.getBoundingClientRect();
      x = event.clientX - box.left;
      y = event.clientY - box.top;
      node.dataset.active = 'true';
      if (!frame) frame = requestAnimationFrame(apply);
    };
    const onLeave = () => { delete node.dataset.active; };
    const section = node.parentElement;

    section.addEventListener('pointermove', onMove, { passive: true });
    section.addEventListener('pointerleave', onLeave);
    return () => {
      cancelAnimationFrame(frame);
      section.removeEventListener('pointermove', onMove);
      section.removeEventListener('pointerleave', onLeave);
    };
  }, []);

  return ref;
};

const HomeHero = ({ home = {} }) => {
  const dotsRef = useDotGrid();

  return (
    <section className={classes.hero}>
      <div className={classes.dots} ref={dotsRef} aria-hidden />
      <div className={classes.container}>
        <div className={classes.inner}>
          <div className={classes.text}>
            <h1 className={classes.title} data-aos="fade-up">
              {home.title || FALLBACK.title}
            </h1>
            <p className={classes.thesis} data-aos="fade-up" data-aos-delay="100">
              {home.thesis || FALLBACK.thesis}
            </p>
            <div className={classes.actions} data-aos="fade-up" data-aos-delay="200">
              <HomeButton href={BITRIX.course}>Записаться на курс</HomeButton>
              <HomeButton to={PATHS.allcourses} theme="white">
                Все курсы
              </HomeButton>
            </div>
          </div>

          <div className={classes.media}>
            {/* Жёлтая фигура из макета — позади выпускников, за ней мягкое свечение. */}
            <span className={classes.glow} aria-hidden />
            <img className={classes.shape} src={heroShape} alt="" aria-hidden />

            <span className={classes.noteBox} data-aos="fade-down" data-aos-delay="300">
              <span className={classes.note}>Ваша карьера начинается здесь</span>
            </span>
            <span className={classes.noteArrowBox} data-aos="fade-down" data-aos-delay="400">
              <img className={classes.noteArrow} src={heroArrow} alt="" aria-hidden />
            </span>

            <div className={classes.photoWrap} data-aos="fade-left" data-aos-delay="100">
              {/* Силуэт людей цветом фона: низ фото растворяется маской, и без него
                  жёлтая фигура просвечивала бы сквозь людей. */}
              <div className={classes.silhouette} aria-hidden>
                <span style={{ WebkitMaskImage: `url(${heroPhoto})`, maskImage: `url(${heroPhoto})` }} />
              </div>
              <div className={classes.photo}>
                <img src={heroPhoto} alt={home.image_alt || 'Выпускники Geeks'} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeHero;
